export function completeHashtags (str) {
    let hashtags = '';
    if (str && str.length > 0) {
        for (let i = 0; i < str.length - 1; i += 1) {
            const cur = str[i];
            const next = str[i + 1];
            hashtags += cur;
            if (i === 0 && next !== '#' && cur !== '#') {
                hashtags = `#${cur}`;
            } else if (cur === ' ' && next !== '#') {
                hashtags += '#';
            }
        }
        hashtags += str[str.length - 1];
        hashtags = hashtags.replaceAll('##', '#');
    }
    return hashtags;
}

export default function unescapeSql (str) {
    if (typeof str !== 'string') return str;
    if (!str) {
        return '';
    }

    // eslint-disable-next-line no-control-regex,no-useless-escape,consistent-return
    return str.replace(/[\0\x08\x09\x1a\n\r"'\\\%]/g, (char) => {
        // eslint-disable-next-line default-case
        switch (char) {
            case '\0':
                return '\\0';
            case '\x08':
                return '\\b';
            case '\x09':
                return '\\t';
            case '\x1a':
                return '\\z';
            case '\n':
                return '\\n';
            case '\r':
                return '\\r';
            case '"':
            case "'":
            case '\\':
            case '%':
                return `${char}`;
        }
    });
}
